module.exports = __webpack_public_path__ + "static/media/dev-actions.7cd03595.svg";